(function () {
  function initTabs() {
    var area = document.querySelector('.s-accordion-desc-area');
    if (!area || area.classList.contains('ss-tabs-ready')) return;

    var panels = Array.prototype.slice.call(area.querySelectorAll('details'));
    if (panels.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'ss-tabs__nav';
    nav.setAttribute('role', 'tablist');

    var buttons = panels.map(function (panel, index) {
      var summary = panel.querySelector('summary');
      var label = summary ? summary.textContent.replace(/\s+/g, ' ').trim() : 'Details';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ss-tabs__btn';
      button.setAttribute('role', 'tab');
      button.textContent = label;
      button.addEventListener('click', function () {
        select(index);
      });
      nav.appendChild(button);
      return button;
    });

    function select(active) {
      panels.forEach(function (panel, index) {
        var on = index === active;
        panel.classList.toggle('is-active', on);
        panel.open = on;
        buttons[index].setAttribute('aria-selected', on ? 'true' : 'false');
        buttons[index].tabIndex = on ? 0 : -1;
      });
      var activeButton = buttons[active];
      if (activeButton && nav.scrollWidth > nav.clientWidth) {
        nav.scrollTo({ left: activeButton.offsetLeft - 16, behavior: 'smooth' });
      }
    }

    area.insertBefore(nav, area.firstChild);
    area.classList.add('ss-tabs-ready');
    select(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
})();
